/**
 * Free-shipping progress bar — Kleinstadt Roastery (custom, update-safe).
 *
 * Keeps every [data-free-shipping-bar] in sync with the live cart total.
 *
 * Why read from /cart.js instead of trusting events: the theme fires different
 * signals for different mutations and they don't all carry a cart payload
 * (add-to-cart only dispatches `ajaxProduct:added`). So we treat any signal as
 * "something changed" and read the authoritative total from the server. One tiny
 * GET per mutation; fully decoupled from theme internals. When an event *does*
 * carry the cart (qty change), we use it directly and skip the round-trip.
 *
 * Holds no business values: threshold and copy come from the rendered markup,
 * so the threshold can change in the snippet without touching this file.
 */
(function () {
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2) + ' €';
  }

  function render(totalCents) {
    document.querySelectorAll('[data-free-shipping-bar]').forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10) || 0;
      var reached = totalCents >= threshold;
      var remaining = Math.max(0, threshold - totalCents);
      var percent = threshold > 0 ? Math.min(100, Math.round((totalCents / threshold) * 100)) : 100;

      bar.classList.toggle('free-shipping-bar--reached', reached);

      var fill = bar.querySelector('[data-fsb-fill]');
      if (fill) fill.style.width = percent + '%';

      var msg = bar.querySelector('[data-fsb-message]');
      if (msg) {
        msg.innerHTML = reached
          ? bar.dataset.msgReached
          : bar.dataset.msgRemaining.replace('[amount]', '<strong>' + formatMoney(remaining) + '</strong>');
      }
    });
  }

  function refreshFromServer() {
    if (!document.querySelector('[data-free-shipping-bar]')) return;
    fetch(ROOT + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price); })
      .catch(function () {});
  }

  // Qty change in cart/drawer carries the cart — use it directly.
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart && typeof e.detail.cart.total_price === 'number') {
      render(e.detail.cart.total_price);
    } else {
      refreshFromServer();
    }
  });

  // Add-to-cart and dev rebuilds carry no cart payload → read from server.
  document.addEventListener('ajaxProduct:added', refreshFromServer);
  document.addEventListener('cart:build', refreshFromServer);
})();
